// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactNavButton-cls1_uq2","cls2":"ImpactNavButton-cls2__HU ImpactNavButton-cls1_uq2"};